import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "LightSpeed ROI";
const LOGO =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_design-merge-preview/artifacts/68ht7sop_IMG_5900.png";
const BASE = "https://www.lightspeedroihq.com";

export default function SEO({ title, description, path = "/", image = LOGO }) {
  const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Booked Jobs for Home Service Pros`;
  const url = `${BASE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
